export const contentTableConfig = {
  title: '渠道列表',
  propList: [
    {prop: 'thirdParty', label: '所属第三方', minWidth: '80'},
    {prop: 'channelName', label: '渠道名称', minWidth: '100'},
    {prop: 'minTriggerQuantity', label: '最低触发量', minWidth: '100', slotName: 'minTriggerQuantity'},
    {prop: 'resourceChange', label: '资源人数折扣', minWidth: '100', slotName: 'resourceChange'},
    {prop: 'repeatChange', label: '增加重复率', minWidth: '100', slotName: 'repeatChange'},
    {prop: 'deleteChange', label: '增加删除率', minWidth: '100', slotName: 'deleteChange'},
    {prop: 'fixedRateStatus', label: '是否开启固定利率', minWidth: '100', slotName: 'fixedRateStatus'},
    {prop: 'fixedRepeatRate', label: '固定重复率', minWidth: '100', slotName: 'fixedRepeatRate'},
    {prop: 'fixedDeleteRate', label: '固定删除率', minWidth: '100', slotName: 'fixedDeleteRate'},
    {label: '操作', minWidth: '120', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
